module.exports = __webpack_public_path__ + "media/assets/images/flags/cm-cc621084aa7912bb6322d6b0cf2e27aa.svg";